import utils from '../utils/util';
import store from '../store';
import config from '../config/index';
import environmentMgr from './environment.manager';
import queryParams from './pageQuery.service';
import * as layerNames from './layerName';
import { container } from './socketIO/container';
import {
  SYNC_CONTEXT_SOURCE,
  CONTEXT_SOURCE,
  USER_TYPE,
} from './socketIO/const';
import {
  userActionInterceptor,
  staticIdDecorator,
} from './socketIO/user.action.interceptor';
import eventBus from './eventBus.service';
import * as types from './eventBusType';
import { URLService } from './url.service';
const eid = '2|1211004|72|102|203475|301135|20191115004';
const exteriorPvaredId = 2594194;
let baseInfo = store.state.baseInfo;
let imgSeriesId = 0;
@staticIdDecorator('layerManager')
class LayerManager {
  /**
   *  跳转看车页面
   * window.postMessage({action:'lookcar',param:{seriesid:3766,specid:27797,url:'',is3d:true}})
   * @param {any} lookCarParam
   */
  openLookCar(lookCarParam) {
    var self = this;
    if (
      !self._checkSeriesidAndSpecid(lookCarParam.seriesid, lookCarParam.specid)
    ) {
      console.warn('360看车车型或者车系id不合法', lookCarParam);
    } else {
      if (lookCarParam.is3d) {
        if (store.state.frame.threeDimensionHall.show) {
          this.close3dLayer(true);
        }
        self.open3dCar(lookCarParam);
      } else {
        self.openExterior(lookCarParam);
      }
      eventBus.$emit(types.RESIZE);
    }
  }
  /**
   * 打开3d看车
   * @param {*} lookCarParam
   */
  @userActionInterceptor()
  open3dCar(lookCarParam) {
    this.open(layerNames.CAR_3D_LAYER, { seriesId: lookCarParam.seriesid });
    store.commit('frame/setThreeDimensionCar', { url: '', show: true });
  }
  /**
   * 关闭3d看车
   */
  @userActionInterceptor()
  close3dCar() {
    if (store.state.frame.threeDimensionHall.isOpen) {
      this.open3dLayer();
    }
    store.commit('frame/setThreeDimensionCar', {
      url: 'about:blank',
      show: false,
    });
    this.close(layerNames.CAR_3D_LAYER);
  }
  /**
   * window.postMessage({action:'lookcar',param:{seriesid:3766,specid:27797,url:'',is3d:false}})
   * 跳转外观页面
   * @param {any} lookCarParam
   */
  openExterior(lookCarParam) {
    var self = this;
    if (!lookCarParam.seriesid) {
      console.warn('外观车系id不合法', lookCarParam);
      return;
    }
    var src = 'm';
    if (utils.browser.isApp || utils.browser.isPriceApp) {
      src = 'app';
    }
    let seriesId = lookCarParam.seriesid;
    let cityId = baseInfo.cityId;
    const _url = `${config.dealerCloud}/vr4s/dache?seriesId=${seriesId}&src=${src}&busi=vr4s&siteid=353&cityId=${cityId}&sortType=2`;
    const sceneName = lookCarParam.sceneName || '';
    let backUrl = self.buildBackUrl(sceneName);
    const dealerId = baseInfo.dealerId;
    const frompvareaid = queryParams.pvAreaId;
    const urlSerivce = new URLService(_url);
    urlSerivce.queryParams
      .append('dealerId', dealerId)
      .append('eid', eid)
      .append('returnurl', backUrl)
      .append('pvareaid', exteriorPvaredId)
      .append('frompvareaid', frompvareaid);
    const targetUrl = urlSerivce.build();
    environmentMgr.getEnv().openPage({ url: targetUrl });
  }
  /**
   * 跳转内饰页面
   * window.postMessage({action:'interior',param:{seriesid:3397}})
   * @param {any} inreriorParam
   */
  @userActionInterceptor()
  openInterior(inreriorParam) {
    if (!inreriorParam.seriesid) {
      console.warn('内饰车系id不合法', inreriorParam);
      return;
    }
    if (store.state.frame.threeDimensionHall.show) {
      this.close3dLayer(true);
    }
    if (store.state.phoneCall.phoneCallStatus) {
      this.open(layerNames.CAR_REALTIME_INTERIOR_LAYER, {
        specId:
          Number(inreriorParam.specid) || Number(inreriorParam.interiorSpecId),
      });
    } else {
      this.open(layerNames.CAR_INTERIOR_LAYER, {
        interiorSpecId: Number(inreriorParam.interiorSpecId),
        url: inreriorParam.url,
      });
    }
    eventBus.$emit(types.RESIZE);
  }
  buildBackUrl(sceneName) {
    let fromUrl = queryParams.backUrl;
    if (!fromUrl) {
      fromUrl = '';
    }
    let backUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    let scenetype = 'full';
    if (store.state.frame.threeDimensionHall.isOpen) {
      scenetype = '3d';
    }
    const frompvareaid = queryParams.pvAreaId;
    const urlSerivce = new URLService(backUrl);
    urlSerivce.queryParams
      .append('scenetype', scenetype)
      .append('startscene', sceneName)
      .append('backurl', encodeURIComponent(fromUrl))
      .append('pvareaid', exteriorPvaredId)
      .append('frompvareaid', frompvareaid);
    backUrl = urlSerivce.build();
    return backUrl;
  }
  /**
   * 打开车系详情页面
   * window.postMessage({action:'config',param:{seriesid:3766,specid:27797}})
   * @param {any} configParam
   */
  @userActionInterceptor()
  openConfig(configParam) {
    this.openConfigForSelf(configParam);
  }
  openConfigForSelf(configParam) {
    console.log({
      type: configParam.type,
    });
    var self = this;
    if (
      !self._checkSeriesidAndSpecid(configParam.seriesid, configParam.specid)
    ) {
      console.warn('车系详情车系id或者车型id不合法', configParam);
      return;
    }
    const dealerId = baseInfo.dealerId;
    store.dispatch('dealer/getSpecListByDealerId', dealerId).then(() => {
      let specItem = store.getters['dealer/specItem'](
        configParam.seriesid,
        configParam.specid,
      );
      if (!specItem) {
        let specList = store.getters['dealer/specList'](configParam.seriesid);
        if (specList.length > 0) {
          specItem = specList[0];
          configParam.specid = specItem.SpecId;
        }
      }
      this.open(layerNames.SPEC_PARAMETER_LAYER, {
        propsData: {
          seriesId: Number(configParam.seriesid),
          specId: Number(configParam.specid),
          type: Number(configParam.type),
        },
      });
    });
  }

  openConfigSpecList(type, seriesId, specId, onSelectItem) {
    if (type === 1) {
      this.openConfigSpecListForSelf(seriesId, specId, onSelectItem);
    } else {
      this.openConfigSpecListAction(seriesId, specId, onSelectItem);
    }
  }
  @userActionInterceptor()
  openConfigSpecListAction(seriesId, specId, onSelectItem) {
    this.openConfigSpecListForSelf(seriesId, specId, onSelectItem);
  }
  openConfigSpecListForSelf(seriesId, specId, onSelectItem) {
    this.open(layerNames.SPEC_PARAMETER_LAYER_SPECLIST, {
      propsData: {
        layerName: layerNames.SPEC_PARAMETER_LAYER_SPECLIST,
        seriesId: Number(seriesId),
        specId: Number(specId),
        onSelectItem:
          onSelectItem ||
          function () {
            return;
          },
      },
    });
  }
  /**
   * 打开车系图片页面
   * window.postMessage({action:'images',param:{seriesid:3766,specid:27797}})
   * @param {any} imgParam
   */
  @userActionInterceptor()
  openImages(imgParam) {
    var self = this;
    console.log('openImages', imgParam);
    if (!imgParam.seriesid && imgSeriesId) {
      imgParam.seriesid = imgSeriesId;
    }
    if (!self._checkSeriesidAndSpecid(imgParam.seriesid, imgParam.specid)) {
      console.warn('车系详情车系id或者车型id不合法', imgParam);
      return;
    }
    imgSeriesId = imgParam.seriesid;
    this.open(layerNames.SPECPIC_LAYER, {
      propsData: {
        title: imgParam.title,
        seriesId: Number(imgParam.seriesid),
        specId: Number(imgParam.specid),
        displayTypeId: 0,
      },
    });
  }
  /**
   * 打开下单页面
   *  window.postMessage({action:'order',param:{seriesid:3766,specid:27797}})
   * @param {any} orderParam
   */
  openOrder(orderParam) {
    if (!orderParam) {
      orderParam = {};
    }
    orderParam.seriesid = orderParam.seriesid || 0;
    orderParam.specid = orderParam.specid || 0;
    this.price(
      orderParam.seriesid,
      orderParam.specid,
      orderParam.eIdKey,
      orderParam.orderType2 || 1,
    ); // 根据不同来源设置eid,siteid
  }
  /**
   * 打开下单成功页面
   *
   * @param {any} orderParam
   */
  openOrderSuccess() {}
  /**
   * 检查车系和车型id的合法性
   * @param {any} seriesid
   * @param {any} specid
   */
  _checkSeriesidAndSpecid(seriesid, specid) {
    if (seriesid && seriesid > 0 && specid && specid > 0) {
      return true;
    }
    return false;
  }
  /**
   * 打开3d展馆
   * */
  open3dLayer() {
    if (store.state.frame.threeDimensionHall.show) {
      return;
    }
    store.commit('loading/setLoadStart', { sceneType: '3d' });
    store.commit('frame/setThreeDimensionHall', {
      show: true,
      isOpen: true,
      style: 'z-index: -1;',
    });
    eventBus.$emit(types.RESIZE);
  }
  /**
   * 关闭3d展馆
   * */
  close3dLayer(isOpenHall) {
    store.commit('frame/setThreeDimensionHall', {
      show: false,
      isOpen: isOpenHall,
      style: '',
    });
    store.commit('setHideBottom', false);
  }
  /**
   * window.postMessage({action:'loaded',param:{type:'vr3d'}})
   * @param {any} loadedParam
   */
  layerLoaded() {
    if (store.state.frame.threeDimensionHall.show) {
      store.commit('loading/setLoadComplete', {
        sceneType: '3d',
        callBack: () => {
          store.commit('setHideBottom', true);
          store.commit('frame/setThreeDimensionHall', {
            show: true,
            isOpen: true,
            style: 'z-index:1',
          });
        },
      });
    }
  }
  @userActionInterceptor()
  price(seriesid, specid, from, orderType2 = 1, activityId = 0, source='') {
    const syncContext = container.get(SYNC_CONTEXT_SOURCE);
    if (syncContext && syncContext.userType === USER_TYPE.SALES) {
      const source = syncContext.getContextSource();
      if (source === CONTEXT_SOURCE.REMOTE) {
        this.toast({ message: '客户正在打开留资弹层！' }, 1500);
      } else {
        this.toast(
          { propsData: { message: '已成功向用户发出活动邀请！' } },
          1500,
        );
      }
      return;
    }
    this.open(
      layerNames.ORDER,
      {
        orderType2: orderType2,
        seriesId: Number(seriesid) || 0,
        specId: Number(specid) || 0,
        eIdKey: from,
        activityId,
        source
      },
      true,
    );
  }
  openVideoList() {
    this.open(layerNames.VIDEO_LIST, {}, true);
  }
  showSceneLoading(isShow) {
    if (isShow === true) {
      store.commit('loading/setLoadStart', { sceneType: 'full' });
    } else {
      store.commit('loading/setLoadComplete', { sceneType: 'full' });
    }
  }

  @userActionInterceptor()
  loadPromotionInfo(newsId, openDetail, opts = {}) {
    store
      .dispatch('news/loadPromotionInfo', { id: newsId, openDetail })
      .then((res) => {
        if (res && res.NewsId) {
          this.openPromotionList(opts);
        }
      });
  }
  @userActionInterceptor()
  loadActivityInfo(actId, opts = {}) {
    store.dispatch('news/loadActivityInfo', actId).then((res) => {
      if (res && res.id) {
        this.openPromotionList(opts);
      }
    });
  }
  /**
   * 打开指定的活动
   * @param {number} pvAreaId
   * @param {number} activityId
   * @param {number} activityType
   * @param {number} salesId
   * @returns
   */
  @userActionInterceptor()
  openDealerAct(activityId, activityType, salesId) {
    const syncContext = container.get(SYNC_CONTEXT_SOURCE);
    if (syncContext && syncContext.userType === USER_TYPE.SALES) {
      const source = syncContext.getContextSource();
      if (source === CONTEXT_SOURCE.REMOTE) {
        this.toast({ message: '客户正在参与店内游戏' }, 1500);
      } else {
        this.toast({ message: '已成功向用户发出活动邀请！' }, 1500);
      }
      return;
    }
    this.open(layerNames.DEALER_ACTIVITY_LAYER, {
      activityId,
      activityType,
      salesId,
    });
  }

  open(layerName, layerData, keepAlive = false) {
    layerData = (layerData && layerData.propsData) || layerData || {};
    eventBus.$emit(types.OPEN_LAYER, {
      layerName,
      keepAlive: keepAlive,
      layerData: layerData,
    });
  }
  close(layerName) {
    eventBus.$emit(types.CLOSE_LAYER, { layerName });
  }
  /**
   * 打开红包
   */
  openRedPacket(opts = {}) {
    this.open(layerNames.RED_PACKET_FORM_LAYER, opts);
  }
  /**
   * 打开分享红包
   * @param {*} redPacketId
   */
  openShareRedPacket(opts) {
    this.open(layerNames.SHARED_RED_PACKET_LAYER, opts);
  }
  /**
   * 打开提示
   * @param {*} opts
   */
  openToast(opts) {
    opts = (opts && opts.propsData) || opts || {};
    opts.zIndex = 10000;
    this.open(layerNames.TOAST, opts, true);
  }
  /**
   * 关闭提示
   */
  closeToast() {
    this.close(layerNames.TOAST);
  }
  /**
   * 打开确认框
   * @param {*} opts
   */
  openConfirm(opts) {
    opts = (opts && opts.propsData) || opts || {};
    this.open(layerNames.CONFIRM, opts);
  }
  @userActionInterceptor()
  openConfirmForPop(opts) {
    const syncContext = container.get(SYNC_CONTEXT_SOURCE);
    if (syncContext && syncContext.userType === USER_TYPE.USER) {
      this.toast({ message: '好的，已发给顾问，请等待回复' }, 1500);
      return;
    }
    opts = (opts && opts.propsData) || opts || {};
    this.open(layerNames.CONFIRM, opts);
  }
  /**
   *  vr带看优先引导-专用
   * @param {*} opts
   */
  openHomeConfirm(opts) {
    opts = (opts && opts.propsData) || opts || {};
    this.open(layerNames.HOME_CONFIRM, opts);
  }
  /**
   *  打开报价单
   * @param {*} opts
   */
  openPriceList(opts) {
    this.open(layerNames.PRICE_LIST, opts);
  }
  /**
   *  打开报价单--车系页面
   * @param {*} opts
   */
  openPriceListSeries(opts) {
    this.open(layerNames.PRICELIST_SERIES_LIST, opts);
  }
  /**
   * 打开toast提示
   * @param {*} opts  配置
   * @param {*} duration  时长
   */
  toast(opts, duration) {
    this.openToast(opts);
    if (this.toastTimer) {
      window.clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.closeToast();
      this.toastTimer = null;
    }, duration);
  }
  openPromotionList(opts) {
    this.open(layerNames.PROMOTION_LIST, opts);
  }
}
const layManager = new LayerManager();
export default layManager;
